<template>
  <div class="ATagHintPage">
    <div class="hintText">如需浏览，请长按网址复制后使用浏览器访问</div>
    <div class="urlText">{{ url }}</div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      url: "",
    };
  },
  mounted: function () {
    this.url = decodeURIComponent(this.$route.query.url);
  },
};
</script>

<style lang="scss" scoped>
@import "./ATagHintPage.scss";
</style>
